// src/store/modules/crm/getters.js
export default {
  // FT-081: доступ = «CRM подключён» (активный add-on: платный или триал) — поле crm_active
  // из payload бэкенда. НЕ plan.included_services (то — «тариф предлагает», питает каталог).
  isCrmEnabled: (state, getters, rootState, rootGetters) => {
    const mc = rootGetters.getMainCompany;
    return !!(mc && mc.crm_active);
  },
  // FT-081: активная триальная CRM-строка (для баннера-отсчёта); null если нет триала
  crmTrialAddon: (state, getters, rootState, rootGetters) => {
    const mc = rootGetters.getMainCompany;
    const addons = (mc && mc.company_addons) || [];
    return addons.find((a) => a.code === "crm" && a.trial_ends_at) || null;
  },
  crmTrialAvailable: (state, getters, rootState, rootGetters) => {
    const mc = rootGetters.getMainCompany;
    return !!(mc && mc.crm_trial_available);
  },
  hasCrmAccess: (state, getters, rootState, rootGetters) => {
    const u = rootGetters.getCurrentUser;
    return !!(u && u.crm_access_enabled === true);
  },
  isCrmAdmin: (state, getters, rootState, rootGetters) => {
    const u = rootGetters.getCurrentUser;
    return !!(u && (u.role === "admin" || u.role === "superadmin"));
  },
  currentPipeline: (state) => {
    if (state.currentPipelineId) {
      const found = state.pipelines.find((p) => p.id === state.currentPipelineId);
      if (found) return found;
    }
    return state.pipelines.find((p) => p.is_default) || state.pipelines[0] || null;
  },
  pipelineStages: (state, getters) => {
    const p = getters.currentPipeline;
    if (!p || !p.pipeline_stages) return [];
    return p.pipeline_stages.slice().sort((a, b) => (a.position || 0) - (b.position || 0));
  },
  leadsForStage: (state) => (stageId) => {
    const bucket = state.leadsByStage[stageId];
    let items = (bucket && bucket.items) || [];
    // unreadOnly/importantOnly — FE-фильтры: и счётчик колонки, и карточки берут отсюда.
    if (state.unreadOnly) items = items.filter((l) => l.has_unread);
    if (state.importantOnly) items = items.filter((l) => l.important);
    return items;
  },
  // FT-154: метаданные бакета для шапки колонки/аккордеона (чип loaded / total, бейдж
  // непрочитанных, sentinel по hasMore). Несуществующая стадия — пустой бакет, не undefined.
  // FT-156 REQ-07: свёрнута ли колонка стадии текущей воронки. Запись воронки — массив
  // stage_id; её нет или она битая (персист из старого бандла, чужие данные) — дефолт:
  // терминальные (won/lost) свёрнуты, остальные развёрнуты (FM-03 — без исключений).
  isStageCollapsed: (state, getters) => (stageId) => {
    const p = getters.currentPipeline;
    const map = state.collapsedStages;
    const record = p && map && typeof map === "object" && !Array.isArray(map) ? map[p.id] : undefined;
    if (Array.isArray(record)) return record.includes(stageId);
    const st = (getters.pipelineStages || []).find((s) => s.id === stageId);
    return !!st && (st.stage_type === "won" || st.stage_type === "lost");
  },
  stageMeta: (state) => (stageId) => {
    const b = state.leadsByStage[stageId];
    return b || { items: [], page: 1, total: 0, unreadCount: 0, hasMore: false, loadingMore: false, countsStale: false };
  },
  // Сумма непрочитанных по стадиям текущей воронки — число в тумблере тулбара (REQ-07),
  // живое через правило счётчиков REQ-02.
  boardUnreadTotal: (state, getters) =>
    getters.pipelineStages.reduce((sum, st) => sum + ((state.leadsByStage[st.id] || {}).unreadCount || 0), 0),
  userById: (state) => (id) => state.usersById[id] || null,
  sourceById: (state) => (id) => state.leadSources.find((s) => s.id === id) || null,
  activeFilters: (state) => {
    const defaults = { q: "", source_id: null, assigned_to_id: null, pipeline_stage_id: null, archived: false };
    return Object.keys(state.filters).filter((k) => state.filters[k] !== defaults[k]);
  },
  conversionActive: (state) => state.conversions.length > 0,
  conversions: (state) => state.conversions,
  conversionByLead: (state) => (leadId) =>
    state.conversions.find((c) => String(c.leadId) === String(leadId)) || null,
};
